import { combineReducers, configureStore } from "@reduxjs/toolkit";
import userReducer from "./reducers/userReducer";
import loaderReducer from "./reducers/loaderReducer";
import menuReducer from "./reducers/menuReducer";

const rootReducer = combineReducers({
	user: userReducer,
	loader: loaderReducer,
	menu: menuReducer
});

const index = configureStore({
	reducer: rootReducer,
});

export default index;
